import { useMemo } from 'react';
import type { Project, Client } from '@altyor-kronos/shared-types';
import { usePolledResource } from '../core/data/usePolledResource';
import { apiList } from '../core/data/restClient';

export interface SearchableProject {
  id: string;
  code: string;
  name: string;
  clientName: string;
  status: Project['status'];
  currentProgram: Project['currentProgram'];
}

function toOptions(
  projects: Array<{ id: string; data: Project }>,
  clients: Map<string, Client>,
): SearchableProject[] {
  return projects.map(({ id, data }) => ({
    id,
    code: data.code,
    name: data.name,
    clientName: clients.get(data.clientId)?.name ?? '',
    status: data.status,
    currentProgram: data.currentProgram,
  }));
}

function useGlobalSearchRest() {
  const projects = usePolledResource<Project & { id: string }>(
    'search-projects',
    () => apiList<Project & { id: string }>('/projects'),
  );
  const clientRows = usePolledResource<Client & { id: string }>(
    'search-clients',
    () => apiList<Client & { id: string }>('/clients'),
  );
  const options = useMemo(() => {
    const clients = new Map<string, Client>();
    for (const c of clientRows.rows) clients.set(c.id, c as Client);
    return toOptions(projects.rows.map((r) => ({ id: r.id, data: r })), clients);
  }, [projects.rows, clientRows.rows]);
  return { options };
}

export function useGlobalSearch() {
  return useGlobalSearchRest();
}
